$('.js-location').each(function() {
  var $href = $(this).attr('href')
  if (location.href.match($href)) {
    $(this).addClass('js-active')
  } else {
    $(this).removeClass('js-active')
  }
})
